import { Box, Typography } from '@mui/material';
import React, { FC } from 'react';
import { UseFormReturn } from 'react-hook-form';

import { useStyles } from '../../styles';
import { LoanFormType } from '../../types';
import { AmountKindForm } from '../amount-kind-form';
import { MoneyField } from '../moneyField';
import { useTranslation } from 'react-i18next';

type Props = {
  isDataLoading: boolean,
  loanForm: UseFormReturn<LoanFormType, object>
  onSave: (e?: React.BaseSyntheticEvent<object, any, any> | undefined) => Promise<void>;
};

export const LoanAmountAndAmountKind: FC<Props> = ({
  isDataLoading,
  loanForm,
  onSave
}) => {
  const classes = useStyles();
  const { control } = loanForm;
  const { t } = useTranslation();

  return (
    <Box style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
      <Box>
        <Typography variant="h6" className={classes.subTitle}>
          {t('loan:amount-kind')}
        </Typography>
      </Box>
      <Box style={{ display: 'flex', gap: '20px', alignItems: 'flex-end' }}>
        <Box style={{ flex: 1 }}>
          <MoneyField
            control={control}
            name="loanAmountEntry.amount"
            label={t('loan:loan-amount')}
            disabled={isDataLoading}
            onBlur={onSave}
          />
        </Box>
        <Box style={{ flex: 1 }}>
          <AmountKindForm
            loanForm={loanForm}
            isLoanLoading={isDataLoading}
            onSave={onSave}
          />
        </Box>
      </Box>
    </Box>
  );
};
